/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateProcedureDto
 */
export interface GenerateProcedureDto {
    /**
     * Patient ID (required - for associating procedure with a patient)
     * @type {string}
     * @memberof GenerateProcedureDto
     */
    patientId: string;
    /**
     * Language of the procedure document
     * @type {string}
     * @memberof GenerateProcedureDto
     */
    language: string;
    /**
     * Description of the procedures taken
     * @type {string}
     * @memberof GenerateProcedureDto
     */
    proceduresTaken: string;
    /**
     * Additional comments
     * @type {string}
     * @memberof GenerateProcedureDto
     */
    additionalComments: string;
}

/**
 * Check if a given object implements the GenerateProcedureDto interface.
 */
export function instanceOfGenerateProcedureDto(value: object): value is GenerateProcedureDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('proceduresTaken' in value) || value['proceduresTaken'] === undefined) return false;
    if (!('additionalComments' in value) || value['additionalComments'] === undefined) return false;
    return true;
}

export function GenerateProcedureDtoFromJSON(json: any): GenerateProcedureDto {
    return GenerateProcedureDtoFromJSONTyped(json, false);
}

export function GenerateProcedureDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateProcedureDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'language': json['language'],
        'proceduresTaken': json['proceduresTaken'],
        'additionalComments': json['additionalComments'],
    };
}

export function GenerateProcedureDtoToJSON(json: any): GenerateProcedureDto {
    return GenerateProcedureDtoToJSONTyped(json, false);
}

export function GenerateProcedureDtoToJSONTyped(value?: GenerateProcedureDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'language': value['language'],
        'proceduresTaken': value['proceduresTaken'],
        'additionalComments': value['additionalComments'],
    };
}

